// src/pages/ResetPassword.js
import React, { useState } from 'react';
import { useLocation, Link, useNavigate } from 'react-router-dom';
import Footer from '../components/Footer';

export default function ResetPassword() {
  const query = new URLSearchParams(useLocation().search);
  const uidb64 = query.get('uid');
  const token  = query.get('token');

  const [password,        setPassword       ] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword,    setShowPassword   ] = useState(false);
  const [loading,         setLoading        ] = useState(false);
  const [error,           setError          ] = useState('');
  const [message,         setMessage        ] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    if (!password || !confirmPassword) {
      setError('Please enter both password fields');
      return;
    }
    if (password !== confirmPassword) {
      setError('The passwords do not match');
      return;
    }

    setLoading(true);
    try {
      const res = await fetch('/api/password-reset-confirm/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          uidb64:       uidb64,
          token:        token,
          new_password: password
        })
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.error || 'Error changing password');
      } else {
        setMessage(data.detail);
        setTimeout(() => navigate('/sign-in'), 2000);
      }
    } catch {
      setError('Network error. Try later');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col min-h-screen font-sans">
      {/* Header */}
      <nav className="bg-[#0F2C5E] text-white p-4 flex items-center">
        <img src="/logo.png" alt="Logo" className="h-8 w-8 mr-2" />
        <span className="font-bold text-xl">2290Pay.org</span>
      </nav>

      {/* Form */}
      <div className="flex-1 flex flex-col items-center justify-center bg-[#E4F2FF] p-4">
        <div className="bg-white w-full max-w-md p-8 shadow-md rounded-md space-y-6">
          <h1 className="text-2xl font-bold text-[#0F2C5E] text-center">
            Reset Password
          </h1>

          <form onSubmit={handleSubmit} className="space-y-4">
            {/* New Password */}
            <div>
              <label htmlFor="password" className="block text-[#0F2C5E] mb-1 text-sm font-medium">
                New Password
              </label>
              <input
                id="password"
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="mt-1 block w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-[#0F2C5E] text-sm"
              />
            </div>

            {/* Confirm Password */}
            <div>
              <label htmlFor="confirmPassword" className="block text-[#0F2C5E] mb-1 text-sm font-medium">
                Confirm Password
              </label>
              <input
                id="confirmPassword"
                type={showPassword ? 'text' : 'password'}
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="••••••••"
                className="mt-1 block w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-[#0F2C5E] text-sm"
              />
            </div>

            {/* Единственная кнопка Show/Hide */}
            <div className="text-right">
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="text-[#0F2C5E] text-sm hover:underline focus:outline-none"
              >
                {showPassword ? 'Hide' : 'Show'}
              </button>
            </div>

            {/* Ошибки и сообщение */}
            {error   && <p className="text-red-500 text-sm">{error}</p>}
            {message && <p className="text-green-600 text-sm">{message}</p>}

            <button
              type="submit"
              disabled={loading}
              className={`w-full bg-[#0F2C5E] text-white py-2 rounded-md text-sm hover:bg-[#0F2C5E]/80 transition ${
                loading ? 'opacity-50 cursor-not-allowed' : ''
              }`}
            >
              {loading ? 'Saving...' : 'Change Password'}
            </button>
          </form>

          <div className="text-center text-sm">
            <Link to="/sign-in" className="text-[#0F2C5E] hover:underline">
              Back to Login
            </Link>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
